module.exports = __webpack_public_path__ + "static/media/app-condutor-icone-android.fdaa473b.jp2";